<!-- 任务点排名 -->
<template>
  <a-card title="平均任务点数" size="small" :bordered="false">
    <div v-if="false" slot="extra">
      <a-radio-group v-model="showModal" button-style="solid" size="small" @change="getReqDevTimeRank">
        <a-radio-button value="person"> 个人 </a-radio-button>
        <a-radio-button value="team"> 团队 </a-radio-button>
      </a-radio-group>
    </div>
    <div id="task-point-average" :style="{ height: height, width: width }" />
  </a-card>
</template>
<script>
import { reqDevTimeRank } from '@/api/data/requirement';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'person',
      myChart: null,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: []
      },
      xAxisData: [],
      series: []
    };
  },
  watch: {
    filterForm() {
      this.getReqDevTimeRank();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById('task-point-average'));
    this.getReqDevTimeRank();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getReqDevTimeRank() {
      reqDevTimeRank({ ...this.filterForm, show_modal: this.showModal }).then(res => {
        this.option.xAxis.data = res.data.x_axis;
        this.option.series = [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'top'
            },
            name: '需求平均研发耗时(单位: 小时)',
            data: res.data.dev_average_series,
            markLine: {
              data: [{ yAxis: 4 }]
            }
          }
        ];
        this.drawChart();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
